const TIME_ZONE = 'America/New_York';

const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
  timeZone: TIME_ZONE,
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit'
});

const dateFormat = new Intl.DateTimeFormat('en-US', {
  timeZone: TIME_ZONE,
  month: 'short',
  day: 'numeric',
  year: 'numeric'
});

const moneyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Database timestamps come back as "YYYY-MM-DD HH:MM:SS" in UTC; the date setting uses ISO with an offset
function toDate(value) {
  if (!value) {
    return null;
  }
  const iso = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(value) ? `${value.replace(' ', 'T')}Z` : value;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** "Tue, Nov 3, 2026, 11:59 PM" in Eastern time, or "TBD" */
export function formatDateTime(value) {
  const date = toDate(value);
  return date ? dateTimeFormat.format(date) : 'TBD';
}

/** "Nov 3, 2026" in Eastern time, or an empty string */
export function formatDate(value) {
  const date = toDate(value);
  return date ? dateFormat.format(date) : '';
}

export function formatMoney(amount) {
  return moneyFormat.format(Number(amount) || 0);
}
